/** Normalize MySQL BIT / Buffer / string values to boolean for storefront display. */
export const toBooleanFromBit = (value, defaultValue = false) => {
  if (value === undefined || value === null) return defaultValue;
  if (typeof value === 'boolean') return value;
  if (value === 1 || value === '1') return true;
  if (value === 0 || value === '0') return false;
  if (typeof value === 'object') {
    if (value.type === 'Buffer' && Array.isArray(value.data)) {
      return value.data[0] === 1;
    }
    if (typeof value[0] === 'number') {
      return value[0] === 1;
    }
  }
  const normalized = String(value).trim().toLowerCase();
  if (['1', 'true', 'yes'].includes(normalized)) return true;
  if (['0', 'false', 'no'].includes(normalized)) return false;
  return defaultValue;
};

export const isFreeDelivery = (product) => toBooleanFromBit(product?.IsFreeDelivery, false);
